import { useMutation } from '@tanstack/react-query';
import { updateNotificationsDownloadedStatus } from 'config/requests/notifications';

type Props = {
  onError?: (error: any) => void;
  onSuccess?: () => void;
};

type ReturnValue = {
  changeDownloadedStatus: (id: string) => void;
};

export function useChangeDownloadedStatus({ onSuccess, onError }: Props): ReturnValue {
  const { mutate: changeDownloadedStatus } = useMutation({
    mutationKey: ['notificationIsDownloaded'],
    mutationFn: (id: string) => updateNotificationsDownloadedStatus(id),
    retry: false,
    onSuccess,
    onError,
  });

  return { changeDownloadedStatus };
}
